import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import { Button } from 'antd';
import _notification from 'modules/notification';
import { Card, Table, Modal, Tag, Tree } from 'antd';
import PageHeader from 'components/enterprise/PageHeader';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopup from '../popup/ConfirmPopup';
import DropdownList from 'components/controls/DropdownList';
import MyInput from 'components/controls/MyInput';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import { IMAGE_DRAG_ROLLNO } from '../../constants/Base64Images';
import FileUpload from '../../components/controls/FileUpload';
import candidateLogo from "assets/img/candidate.png";
import ButtonComponent from 'components/controls/Button';
import xls from '../../assets/template/BankTxnFileTemplate.xlsx';
import moment from 'moment';
import CandidateAssignedList from './CandidateAssignedList_new';
import { createGlobalStyle } from 'styled-components';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
const { TreeNode } = Tree;

let img = new Image();
img.src = IMAGE_DRAG_ROLLNO;
img.width = '50px';


class GenerateRollNumbers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            centerList: [],
            batchList: [],
            totalStudents: 0,
            postList: [],
            generatedRollNumbers: [],
            postID: 1,
            sequenceSeries: 1000,
            loading: true,
            showRegeneration: false,
            ConfirmPopup: false,
            showCandidateAssignedList: false,
            rowData: {},
            examCardDownloadCount: 0,
        };
    }

    componentDidMount() {
        console.clear();
        this.fillFilterDropdown();
    }

    fillFilterDropdown = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let centerList = await _AdminService.GetAllCenter();
                    let batchList = await _AdminService.GetAllClassRoom();
                    let postList = await _AdminService.GetAllPost();
                    let existingRollNumberData = await _AdminService.GetAllStudentRollNumberData(this.state.postID);

                    //console.log("centerList ", centerList.data);
                    //console.log("batchList ", batchList.data);
                    //console.log("postList ", postList.data);
                    //console.log("existingRollNumberData ", existingRollNumberData.data);

                    if (existingRollNumberData.data.length > 0 && this.state.postID != 0) {
                        //if (0 > 1) {
                        _notification.showMessage('info', "Roll numbers already generated for this Exam/Post");
                        this.setState({
                            ...this.state,
                            postList: postList.data,
                            generatedRollNumbers: existingRollNumberData.data,
                            showRegeneration: true,
                            ConfirmPopup: false,
                            loading: false,
                        });
                        return;
                    }


                    let defaultPostID = this.state.postID;

                    //console.log("defaultPostID: ", defaultPostID);


                    var filteredCenterByPost = batchList.data.filter(item => item.AppliedPost_Id == defaultPostID);

                    //console.log("filteredCenterByPost: ", filteredCenterByPost);

                    var result = filteredCenterByPost.reduce(function (_this, val) {
                        return _this + val.AssignedCount
                    }, 0);

                    var data = this.generateNewRollNumbers(filteredCenterByPost);


                    this.setState({
                        ...this.state,
                        centerList: centerList.data,
                        postList: postList.data,
                        batchList: data,
                        generatedRollNumbers: existingRollNumberData.data,
                        totalStudents: result,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }


    generateNewRollNumbers = (data) => {
        try {
            var result = data.reduce(function (_this, val) {
                return _this + val.AssignedCount
            }, 0);

            //console.log("In generateNewRollNumbers: ", this.state.sequenceSeries);

            let currentRollNo = this.state.sequenceSeries;

            data.map((item, index) => {
                item["startRollNo"] = 0;
                item["endRollNo"] = 0;

                if (item.AssignedCount > 0) {
                    item["startRollNo"] = currentRollNo + 1;
                    currentRollNo = currentRollNo + item.AssignedCount;
                    item["endRollNo"] = currentRollNo;
                }
            })

            return data;
        } catch (e) {
            _notification.showMessage('error', "Error occured while generating roll numbers. Please try again.");
            return [];
        }
    }

    swapElements = (array, index1, index2) => {
        let temp = array[index1];
        array[index1] = array[index2];
        array[index2] = temp;
    };

    // new functions
    handleDrag(item, e) {
        //console.log("Dragging...", item)
        let dragIndex = this.state.batchList.findIndex(x => x.Id == item.Id);
        e.dataTransfer.setData("item", dragIndex);
        e.dataTransfer.setDragImage(img, 0, 0);
    }

    handleDrop(item, info) {
        //console.log("Drop...", item, info)

        try {
            document.getElementById("batch_" + item.Id).style.backgroundColor = "";
            document.getElementById("batch_" + item.Id).style.transform = "";
        } catch { }

        let dragIndex = info.dataTransfer.getData("item");
        let dropIndex = this.state.batchList.findIndex(x => x.Id == item.Id);

        //console.log("dragIndex: ", dragIndex, ' dropInded: ', dropIndex);

        this.swapElements(this.state.batchList, dragIndex, dropIndex);

        var data = this.generateNewRollNumbers(this.state.batchList);

        this.setState({
            ...this.state,
            batchList: data,
            loading: false,
        });

    }

    onDropdownChange = (event) => {
        //console.log([event.target.name], '  -  ', event.target.value);

        this.setState({
            ...this.state,
            [event.target.name]: event.target.value,
            showRegeneration: false,
        });

        if (event.target.name == 'postID' && event.target.value == 0) {
            this.setState({
                ...this.state,
                batchList: [],
                postID: 0,
                showRegeneration: false,
                loading: false,
            });
        }
        else {
            if (event.target.name == 'postID')
                this.fillFilterDropdown();
        }
    }

    onTextChange = (event) => {

        if (event.target.name == 'sequenceSeries' && isNaN(event.target.value))
            return;

        if (event.target.name == 'sequenceSeries' && Number(event.target.value) < 0)
            return;


        this.setState({
            ...this.state,
            [event.target.name]: Number(event.target.value),
        });
    }

    handleKeyDown = (event) => {
        //console.log(event.key);
        if (event.key == "Enter") {
            try {
                this.setState({
                    loading: true
                }, async () => {

                    try {

                        var data = this.generateNewRollNumbers(this.state.batchList);

                        this.setState({
                            batchList: data,
                            loading: false,
                        });

                    } catch (e) {
                        // TODO
                        this.setState({ loading: false });
                        console.log('Error: ', e);
                    }

                });
            } catch (e) { }
        }
    }

    handleOnBlur = (event) => {
        try {
            this.setState({
                loading: true
            }, async () => {

                try {

                    var data = this.generateNewRollNumbers(this.state.batchList);

                    this.setState({
                        batchList: data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }

            });
        } catch (e) { }
    }

    onCancel = () => {
        this.setState({
            ...this.state,
            postID: 0
        });

        this.fillFilterDropdown();
    }

    submitBatchRollNumberOrder = () => {
        //console.log("Submit Generate Roll Number Request");

        let params = [];
        this.state.batchList.map(item => {
            let record = {
                "Applied_Post_Id": this.state.postID,
                "Center_Id": item.Center_Id,
                "ClassRoom_Id": item.Id,
                "Start_Roll_Number": item.startRollNo,
                "End_Roll_Number": item.endRollNo,
                "Created_Date": moment()
            };

            params.push(record);
            //console.log("Exam: ", item.AppliedPost_Id, " Center: ", item.Center_Id, ' Batch: ', item.Id, " Roll No. Start: ", item.startRollNo, ' End: ', item.endRollNo, "AssignedCount: ", item.AssignedCount);
        })

        let finalParam = { lstStudentRollNumberModel: params };
        //console.log("Final data: ", finalParam);


        try {
            this.setState({ loading: true }, async () => {
                try {
                    const response = await _AdminService.AddUpdateStudentRolleNumber(finalParam);
                    //console.log("Post response: ", response);
                    if (response.status == 200 && response.data.IsSuccess) {
                        _notification.showMessage('success', "Roll Numbers generated successfully.");
                        this.setState({
                            loading: false,
                            postID: 0,
                            showRegeneration: false,
                            sequenceSeries: 1000,
                        });
                    }
                    else {
                        _notification.showMessage('error', response.data.Message);
                    }

                    this.fillFilterDropdown();
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }
    }

    submitRegenerateRollNumber = () => {
        //console.log("Submit Generate Roll Number Request");

        let postID = this.state.postID;
        //console.log("Final data: ", postID);


        try {
            this.setState({ loading: true, ConfirmPopup: false }, async () => {
                try {
                    const response = await _AdminService.RegenerateStudentRollNumber(postID);
                    //console.log("Post response: ", response);
                    if (response.status == 200 && response.data.IsSuccess) {
                        _notification.showMessage('success', "Existing Roll Numbers cleaned successfully.");
                        this.setState({
                            loading: false,
                            postID: postID,
                            showRegeneration: false,
                            sequenceSeries: 1000,
                            ConfirmPopup: false
                        });
                    }
                    else {
                        _notification.showMessage('error', response.data.Message);
                    }

                    this.fillFilterDropdown();
                } catch (e) {
                    // TODO
                    this.setState({ loading: false, ConfirmPopup: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }
    }

    ConfirmPopup(ConfirmPopup) {
        let examCardDownloadCount = 0;
        try {
            let temp = this.state.postList.find(x => x.Id == this.state.postID)
            examCardDownloadCount = temp.ExamCardDownloadedCount;
            //console.log("examCardDownloadCount: ", examCardDownloadCount);
        }
        catch { }
        this.setState({ ConfirmPopup, examCardDownloadCount });
    }

    // handleUpdate = async (input) => {
    //     if (this.validateFormData()) {
    //         return
    //     }

    //     const params = {
    //         Qualification_Name: this.state.rowData.Qualification_Name,
    //         Qualification_Specilisation: this.state.rowData.Qualification_Specilisation,
    //         ParentId: this.state.rowData.ParentId,
    //         Id: this.state.rowData.Id
    //     }

    //     console.log("Final data: ", params);

    //     try {
    //         this.setState({ loading: true }, async () => {
    //             try {
    //                 const response = await _AdminService.CreateSpecialization(params);
    //                 console.log("Post response: ", response);
    //                 if (response.status == 200) {
    //                     _notification.showMessage('success', "Specialization saved successfully.");
    //                     this.setState({
    //                         categoryError: "",
    //                         degreeError: "",
    //                         showModel: false,
    //                         loading: false,
    //                         highlightedRowID: params.Id
    //                     });
    //                     this.getAllSpecialization();
    //                 }
    //                 else {
    //                     _notification.showMessage('error', response.data.message);
    //                 }
    //             } catch (e) {
    //                 // TODO
    //                 this.setState({ loading: false });
    //                 console.log('Error: ', e);
    //                 _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
    //             }
    //         });
    //     } catch (e) { }
    // }

    // Drag enter
    onDragEnter = (eve, e) => {
        e.preventDefault();
        document.getElementById(eve).style.backgroundColor = "#ebde34";
        document.getElementById(eve).style.transition = "0.5s";
        document.getElementById(eve).style.transform = "scale(1.03)";
    }

    onDragLeave = (eve, e) => {
        document.getElementById(eve).style.backgroundColor = "";
        document.getElementById(eve).style.transform = "";
    }

    onViewClick = (value) => {
        //console.log('params ', value);
        this.setState({
            rowData: {
                CenterName: value.CenterName,
                Name: value.ClassRoomName,
                Center_Id: value.Center_Id,
                Id: value.ClassRoom_Id,
                Start_Roll_Number: value.Start_Roll_Number,
                End_Roll_Number: value.End_Roll_Number,
                readOnly: true
            },
            showCandidateAssignedList: true
        });
    };

    closeCandidateAssignedModel(value = false) {
        this.setState({ showCandidateAssignedList: false });
    }

    handleDownload = async () => {
        //console.log("reached: ", this.state);

        try {
            this.setState({ loading: true }, async () => {
                try {

                    const response = await _AdminService.exportBatchData(this.state.postID);
                    //console.log("File response: ", response);

                    if (response.status == 200) {
                        let alink = document.createElement('a');
                        alink.href = _AdminService.exportBatchDataToExcel(response.data);
                        alink.download = response.data;
                        alink.click();

                        this.setState({
                            loading: false,

                        });
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });

                }
            });
        } catch (e) { }
    }

    exportData = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {

                    const response = await _AdminService.exportStudentBatchData(this.state.postID);
                    //console.log("File response: ", response);

                    if (response.status == 200) {
                        let alink = document.createElement('a');
                        alink.href = _AdminService.exportStudentBatchDataToExcel(response.data);
                        alink.download = response.data;
                        alink.click();

                        this.setState({
                            loading: false,

                        });
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });

                }
            });
        } catch (e) { }
    }

    render() {
        const TableColumns = [
            {
                title: 'Post Name',
                dataIndex: 'PostName',
                filterSearch: true,
                width: '10%',
                key: 'PostName',
                // sorter: (a, b) => a.PostName.localeCompare(b.PostName)
            },
            {
                title: 'Center Name',
                dataIndex: 'CenterName',
                filterSearch: true,
                width: '13%',
                key: 'CenterName',
                sorter: (a, b) => a.CenterName.localeCompare(b.CenterName)
            },
            {
                title: 'Batch Name',
                dataIndex: 'ClassRoomName',
                filterSearch: true,
                width: '7%',
                key: 'ClassRoomName',
                sorter: (a, b) => a.ClassRoomName.localeCompare(b.ClassRoomName)
            },
            {
                title: 'Batch Date',
                dataIndex: 'Exam_Date',
                filterSearch: true,
                width: '7%',
                key: 'Exam_Date',
                render: (text, record) => (
                    moment(record.Exam_Date).isValid() ? moment(record.Exam_Date).format("DD-MMM-YYYY") : ''
                ),
            },
            {
                title: 'Batch Time',
                dataIndex: 'Exam_Time',
                filterSearch: true,
                width: '13%',
                key: 'Exam_Time',
                sorter: (a, b) => a.Exam_Time.length - b.Exam_Time.length,
            },
            {
                title: 'Start Roll Number',
                dataIndex: 'Start_Roll_Number',
                filterSearch: true,
                width: '7%',
                key: 'Start_Roll_Number',
                sorter: (a, b) => a.Start_Roll_Number - b.Start_Roll_Number
            },
            {
                title: 'End Roll Number',
                dataIndex: 'End_Roll_Number',
                filterSearch: true,
                width: '7%',
                key: 'End_Roll_Number',
                sorter: (a, b) => a.End_Roll_Number - b.End_Roll_Number
            },
            {
                title: 'Count',
                dataIndex: 'Count',
                filterSearch: true,
                width: '5%',
                key: 'Count',
                render: (text, record) => (
                    (record.End_Roll_Number != 0 && record.Start_Roll_Number != 0) ? (record.End_Roll_Number - record.Start_Roll_Number) + 1 : 0
                ),
            },
            {
                title: 'Action',
                dataIndex: '',
                key: 'Id',
                width: '5%',
                render: (value) => {
                    return (
                        <>
                            <Tag onClick={(event) => this.onViewClick(value)} color="green">View</Tag>
                        </>
                    );
                }
            },

        ];

        const candidateAssignedListPopup = (<Modal
            centered={true}
            width={1200}
            bodyStyle={{
                height: "100%",
                padding: 10,
                paddingTop: 40,
                alignItems: "center",
                justifyContent: "center",
                //display: " flex"
            }}
            className="modelPopAnt"
            visible={this.state.showCandidateAssignedList}
            onCancel={() => this.closeCandidateAssignedModel(false)}
            footer={false}
        >
            <CandidateAssignedList
                onCancel={() => this.closeCandidateAssignedModel(false)}
                //onStateChange={this.onApproveRejectChange}
                popupData={this.state.rowData}
                //onCandidateDeallocation={this.candidateRemoved}
                message="Are you sure, you want to delete this post?"
            />
        </Modal>);

        if (this.state.loading)
            return <LoadingSpinner/>

        return (
            <>
                <div className="">
                    <PageHeader
                        title="Generate Roll Numbers"
                        breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Candidates' }, { label: 'Generate Roll Numbers' }]}
                    />
                    <div className="admin-custom-table px-2"> 
                        <div className=" py-3 ">
                            <div className="search-wrap ">
                                <div className="d-flex align-items-center"  style={{ visibility: this.state.loading ? "hidden" : "visible" }}>
                                    <DropdownList 
                                        value={this.state.postID}
                                        name="postID"
                                        onChange={this.onDropdownChange}
                                        placeholder="Select Post"
                                        isRequired={false}
                                        options={this.state.postList}
                                        wrapClass="mb-0"
                                    />
                                    <label className="mb-0" style={{ marginLeft: '32px' }}>Roll No. Series</label>
                                    <div className="col-sm-1">
                                        <MyInput
                                            type="numeric"
                                            value={this.state.sequenceSeries}
                                            name="sequenceSeries"
                                            onChange={this.onTextChange}
                                            onKeyDown={this.handleKeyDown}
                                            onBlur={this.handleOnBlur}
                                            wrapClass="wrap mb-0 w-100"
                                            isRequired={true}
                                            errorState={this.state.mobileError}
                                            errorMessage={this.state.mobileError}
                                        />
                                    </div>

                                    <div style={{ flex: '1 0 auto' }}>
                                        <Button 
                                            className="button-global button-primary ml-3 mr-2  autoHeight"
                                            onClick={this.handleDownload} disabled={!this.state.showRegeneration}>Export Batch Data</Button>
                                        <Button 
                                        className="button-global button-primary ml-3 mr-2  autoHeight"
                                        style={{ marginLeft: '20px' }} onClick={this.exportData} disabled={!this.state.showRegeneration}>Export Candidate Data</Button>
                                    </div>
                                </div>
                                
                            </div>

                        </div>
                    </div>
                    <div className=" analysisWrap " >
                        <div className='centerDivGenerateRollNo'>

                            {this.state.showRegeneration ? <div className="" style={{ width: '100%' }} >
                                <Table size='small'
                                    bordered
                                    rowKey='Id'
                                    columns={TableColumns}
                                    dataSource={this.state.generatedRollNumbers}
                                    //pagination={{ pageSize: 99999, current: 1 }}
                                    pagination={false}
                                    //footer={() => <label style={{ textAlign: 'right', marginRight: '20px' }}>Total Records: {this.state.data.length}</label>}
                                    //onChange={this.onTableAction}
                                    rowClassName={(record, index) => (index % 2 ? 'odd' : 'even')}
                                    className="table-striped-rows admin-table" /></div> : <></>}

                            {!this.state.showRegeneration ?
                                this.state.batchList.map((item, index) => (
                                    <div key={item.Id} id={"batch_" + item.Id}
                                        onDragOver={(eve) => this.onDragEnter("batch_" + item.Id, eve)}
                                        onDragLeave={(eve) => this.onDragLeave("batch_" + item.Id, eve)}
                                        className='centerDivBatchDivGenerateRollNo' draggable onDragStart={(event) => this.handleDrag(item, event)}
                                        onDrop={(event) => this.handleDrop(item, event)} >
                                        <div key={index} style={{ width: '370px' }}>
                                            <table style={{ width: '100%', marginLeft: '10px' }}>
                                                <tbody>
                                                    <tr >
                                                        <td rowSpan={3}>
                                                            <label style={{ textAlign: 'start', marginTop: '2px', fontSize: '14px' }}>{item.Name}</label>
                                                        </td>
                                                        <td> <label style={{ textAlign: 'start', marginTop: '2px', fontSize: '14px' }}>{item.CenterName}</label></td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <label style={{ marginTop: '-8px', fontWeight: 'bold', fontSize: '13px' }}>
                                                                Roll No. From: <span className="color-red" style={{ fontWeight: 'bold', fontSize: '14px' }}> {item.startRollNo}</span> to
                                                                <span className="color-red" style={{ fontWeight: 'bold', fontSize: '14px' }}> {item.endRollNo}</span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label style={{ float: 'right', fontWeight: 'bold', fontSize: '13px', marginRight: '15px', marginTop: '-15px' }}>{item.AssignedCount}
                                                                <img height={16} width={16} src={candidateLogo} style={{ marginTop: '-3px' }}></img>
                                                            </label>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={2}>
                                                            <label style={{ float: 'left', marginTop: '-8px' }}>{moment(item.Exam_Date).isValid() ? moment(item.Exam_Date).format('DD-MMM-YYYY') : ""} - {item.Exam_Time}</label>
                                                        </td>

                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                ))
                                : <></>}
                        </div>

                        <hr></hr>

                        <div style={{ width: '100%' }} className='px-2'>
                            <div >
                                    <div style={{ textAlign: 'right' }}>

                                        {!this.state.showRegeneration ? <>
                                            <ButtonComponent
                                                id="btnCancel"
                                                type="button"
                                                value="Cancel"
                                                className="button-global button-secondary autoHeight small mr-3"
                                                onClick={this.onCancel} />

                                            <ButtonComponent
                                                id="btnSubmit"
                                                type="button"
                                                value="Generate Roll Numbers"
                                                className="button-global button-primary autoHeight autoWidth"
                                                onClick={this.submitBatchRollNumberOrder} /> </> : <></>}

                                        {this.state.showRegeneration ? <>
                                            <ButtonComponent
                                                id="btnSubmit"
                                                type="button"
                                                value="Re-Generate Roll Numbers"
                                                className="button-global button-primary autoHeight autoWidth"
                                                onClick={() => this.ConfirmPopup(true)} /> </> : <></>}
                                    </div>
                                
                            </div>
                            <div className="note-wrap p-3 gl-bxbr my-3">
                                    <h5 className='note-heading'>Note:</h5>
                                    <div>
                                        <p>
                                            This screen allows you to rearrange batch orders to generate roll numbers sequentially.<br />
                                            Drag the batch which you want to change the order and drop it on another batch to swap.&nbsp;<br />
                                            Once batch order arrangement is done click on &quot;Generate Roll Numbers&quot; button to generate Roll numbers in specified sequence.
                                        </p>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
                <Modal
                    centered={true}
                    width={600}
                    bodyStyle={{
                        height: "280px",
                        padding: 0,
                        alignItems: "center",
                        justifyContent: "center",
                        display: " flex"
                    }}
                    className="modelPopAnt admin-home"
                    visible={this.state.ConfirmPopup}
                    onCancel={() => this.ConfirmPopup(false)}
                    footer={false}
                >
                    <ConfirmPopup
                        onCancel={() => this.ConfirmPopup(false)}
                        onOk={this.submitRegenerateRollNumber}
                        message={<div style={{ textAlign: 'center', width: '100%', height: '100%' }}>
                            <p style={{ textAlign: 'center', marginTop: '50px', fontWeight: 'bolder' }}>
                                <span style={{ fontSize: '16px', color: 'red' }}>
                                    Roll Number are already generated for this Exam.<br /><br />
                                    {this.state.examCardDownloadCount > 0 ?
                                        `Exam cards has been downloaded by ${this.state.examCardDownloadCount} candidate(s). Re-generating of roll numbers may change existing roll number sequence.` :
                                        ""}
                                    <br /><br />Are you sure you want to clean existing and re-generate the Roll Numbers again?<br /><br />
                                </span>
                            </p>
                        </div>}
                    />
                </Modal>

                {this.state.showCandidateAssignedList ? candidateAssignedListPopup : <></>}
            </>
        );
    }
}

export default GenerateRollNumbers;